<template>
  <header>
    <div class="columns is-mobile">
      <div class="column is-narrow">
        <router-link to="/">
          <img :src="logo" class="logo"/>
        </router-link>
      </div>
      <div class="column is-narrow">
        <button class="button header-button has-text-primary" @click="$router.push('/')">
          <fa-icon :icon="faUsers"/>
          Overview
        </button>
      </div>
      <div v-if="isAdministrator" class="column is-narrow">
        <button class="button header-button has-text-primary" @click="$router.push('/reporting')">
          <fa-icon :icon="faChartPie"/>
          Reporting
        </button>
      </div>
      <div v-if="isAdministrator" class="column is-narrow">
        <header-dropdown>
          <template slot="trigger">
            <fa-icon :icon="faWrench"/>
            Manage
          </template>
          <template>
            <router-link class="dropdown-item has-text-primary" to="/manage/activity-groups">
              <fa-icon :icon="faChartNetwork"/>
              Activity Groups
            </router-link>
            <router-link class="dropdown-item has-text-primary" to="/manage/users">
              <fa-icon :icon="faUserCog"/>
              Users
            </router-link>
            <router-link class="dropdown-item has-text-primary" to="/manage/usergroups">
              <fa-icon :icon="faUsers"/>
              User Groups
            </router-link>
            <!-- <router-link class="dropdown-item" to="/manage/settings">
              <fa-icon :icon="faCogs" />Settings
            </router-link>-->
          </template>
        </header-dropdown>
      </div>
      <!-- Empty full width column to fill space -->
      <div class="column"></div>
      <div class="column is-narrow">
        <header-dropdown :isRight="true" class="margin-right-2">
          <template slot="trigger">
            <fa-icon :icon="faUser"/>
            <span v-if="session" class="is-hidden-mobile">{{ session.fullName }}</span>
          </template>
          <template>
            <!-- <a href="#" class="dropdown-item" @click="showChangePasswordModal = true">
              <fa-icon :icon="faKey" />Change Password
            </a>-->
            <a class="dropdown-item" href="#" @click="logout">
              <fa-icon :icon="faPowerOff"/>
              Logout
            </a>
          </template>
        </header-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import {mapGetters} from "vuex"
import {IS_ADMINISTRATOR, SESSION} from "@/stores/application/getters"
import {LOGOUT} from "@/stores/application/actions"
import logo from "@/assets/logo-white.png"
import {
  faChartPie,
  faCogs,
  faKey,
  faPowerOff,
  faUser,
  faUserCog,
  faUsers,
  faWrench
} from "@fortawesome/free-solid-svg-icons"
import {faChartNetwork} from "@fortawesome/pro-solid-svg-icons"
import headerDropdown from "@/components/header-dropdown"

export default {
  components: {
    headerDropdown
  },
  computed: {
    ...mapGetters({
      session: SESSION,
      isAdministrator: IS_ADMINISTRATOR
    })
  },
  data() {
    return {
      logo,
      faUsers,
      faChartPie,
      faCogs,
      faUser,
      faPowerOff,
      faKey,
      faUserCog,
      faChartNetwork,
      faWrench
    }
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT).then(() => this.$router.push("/login"));
    }
  }
}
</script>

<style lang="sass" scoped>
header
  background-color: white

.logo
  height: 75px
  margin-top: 5px
  margin-left: 10px

svg
  margin-right: 5px

.header-button
  border: none !important
  box-shadow: none !important
  margin-top: 25px

@media (max-width: 576px)
  .logo
    height: 40px
    margin-top: 5px
    margin-left: 5px
</style>